import produce from 'immer';
import React, { FC, useRef } from 'react'
import { useDrop } from 'react-dnd';
import { useDispatch, useSelector } from 'react-redux';
import { startEditProtoType } from '../../../actions/protoTypeAction';
import { Form } from '../../../models/formModel';
import { getPrototype } from '../../../selectors/protoTypeSelector';
import { ItemTypes } from '../../../utils/itemTypes';
import '../prototypeComponent.scss'
import FormRowComponent from './formRowComponent';

const PrototypeCreateArea :FC = () => {
    const dispatch = useDispatch();
    const ref = useRef<HTMLDivElement>(null);
    const prototypeState = useSelector(getPrototype);

    const [{ isOver, isOverCurrent }, drop] = useDrop({
        accept: ItemTypes.FORM_DRAG,
        drop(item : Form, monitor) {
          const didDrop = monitor.didDrop();
          if (didDrop) {
            return;
          }
          console.log(item);
          const newProtoTypeState = produce(prototypeState , draft => { draft.formList.push(item)})
          dispatch(startEditProtoType(newProtoTypeState));
        },
        collect: (monitor) => ({
          isOver: monitor.isOver(),
          isOverCurrent: monitor.isOver({ shallow: true }),
        }),
      });

    drop(ref);

    const renderRows = () => {
      let numberOfRows = Math.ceil(prototypeState.formList.length/6);
      let startIndex = 0;
      let isLeftDownArrow = false;
      let rowList = [];
      for (let index = 0; index < numberOfRows; index++) {
          let row = {
            rowNumber : index+1,
            formList : prototypeState.formList,
            isReverse : index%2 == 0 ? false : true,
            isLeftDownArrow : isLeftDownArrow,
          }
          isLeftDownArrow = true;
          startIndex = startIndex + 5;
          rowList.push(row);
      }
      console.log(rowList);
        return rowList.map((row) => {
          return <FormRowComponent formList = {row.formList} rowNumber={row.rowNumber} isReverse={row.isReverse} isLeftDownArrow={row.isLeftDownArrow} />  
        })
    }
    return (
        <div className="creation-area">

            {renderRows()}

        </div>
    )
}

export default PrototypeCreateArea
